import Alpine from 'alpinejs'

const data = (params = {}) => ({
  /**
   *  Data
   */
  selectors: 'input, select',

  /**
   *  Targets
   */

  targets: {
    trigger: {
      ['x-init']: 'setAutoSubmit'
    }
  },

  /**
   *  Main & Event Callback
   */

  init() {
  },

  /**
   *  Public Function
   */

  /**
   *  Value Changed
   */

  /**
   *  Private Function
   */
  async setAutoSubmit() {
    this.$el.querySelectorAll(this.selectors).forEach(dom => {
      // 避免比tomselect套用快
      setTimeout(() => {
        dom.disabled = dom.value.length === 0
        if ( dom.tomselect ) {
          if ( dom.disabled ) {
            dom.tomselect.setDisabled(false)
            dom.disabled = true
          }
        } else {
          dom.disabled = false
        }
        dom.setAttribute('x-on:change', '$el.disabled = $el.value.length === 0; $el.form.requestSubmit()')
      }, 150)
    })
  },

  ...params
})

Alpine.data('AutoSubmitForm', data)
export default data
